<app-exam-header [pageTitle]="'Contact Us'"></app-exam-header>
<div class="page-content"> 

    <!-- Ihbox -->
    <section class="section-xl">
        <div class="container">
            <div class="pbmit-heading-subheading text-center">
                <h4 class="pbmit-subtitle">GET IN TOUCH</h4>
                <h2 class="pbmit-title">{{contactPageObj.title}}</h2>
                <div class="pbmit-heading-desc pt-2" [innerHTML]="contactPageObj.description"></div>
            </div>
            <div class="row contact-boxes"> 
                <div class="col-12">
                    <div class="contact-box">
                        <div class="contact-box-inner">
                            <div class="icon-wrapper">
                                <i class="pbmit-lyfpro-icon pbmit-lyfpro-icon-pin"></i>
                            </div>
                            <div class="content-wrapper">
                                <h2 class="pbmit-element-title">Our Location</h2>
                                <div class="pbmit-heading-desc-box" [innerHTML]="address.description"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="contact-box">
                        <div class="contact-box-inner">
                            <div class="icon-wrapper">
                                <i class="pbmit-lyfpro-icon pbmit-lyfpro-icon-call"></i>
                            </div>
                            <div class="content-wrapper-contact">
                                <h2 class="pbmit-element-title">Phone Number</h2>
                                <div class="pbmit-heading-desc-box"><span [innerHTML]="contactNumber.description"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">    
                    <div class="contact-box">
                        <div class="contact-box-inner">
                            <div class="icon-wrapper">
                                <i class="pbmit-lyfpro-icon pbmit-lyfpro-icon-email-1"></i>
                            </div>
                            <div class="content-wrapper-email">
                                <h2 class="pbmit-element-title">Email Address</h2>
                                <div class="pbmit-heading-desc-box">Support@sharaniponguru.me</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class = "social-media-icons">
            <a href = "https://www.facebook.com/sharaninarayanaofficial/" target = "_blank">
                <i class = "fab fa-facebook" style="color: #1877f2"></i>
            </a>
            <a href = "https://www.instagram.com/sharaninarayanaofficial/" target = "_blank">
                <i class = "fab fa-instagram" style="color: #e4405f"></i>
            </a>
            <a href = "https://www.linkedin.com/in/sharaninarayanaofficial/" target = "_blank">
                <i class = "fab fa-linkedin" style="color: #0077b5"></i>
            </a>
            <a href = "https://www.youtube.com/@TheSharaniPonguruWay" target = "_blank">
                <i class = "fab fa-youtube" style="color: #ff0000"></i>
            </a>
            <a href = "https://x.com/sharaniponguru" target = "_blank">
                <i class = "fab fa-twitter" style="color: #1da1f2"></i>
            </a>
        </div> -->
    </section>
    <!-- Ihbox End -->
</div>
<app-exam-footer></app-exam-footer>